class Navigation {
  instance = null;
}

export { Navigation }; // eslint-disable-line import/prefer-default-export
